// Hand-assembled route tree (code-based routing — no @tanstack/router-vite-plugin).
// If the file-based plugin is adopted later, this file becomes plugin-generated.

import { Route as rootRoute } from './routes/__root';
import { Route as IndexRoute } from './routes/index';
import { Route as AuthedRoute } from './routes/_authed';
import { Route as AuthedMailboxRoute } from './routes/_authed/mailbox';
import { Route as AuthedAdminRoute } from './routes/_authed/admin';
import { Route as AuthedFiltersRoute } from './routes/_authed/filters';
import { Route as AuthedLogsRoute } from './routes/_authed/logs';

export const routeTree = rootRoute.addChildren([
  IndexRoute,
  AuthedRoute.addChildren([AuthedMailboxRoute, AuthedAdminRoute, AuthedFiltersRoute, AuthedLogsRoute]),
]);
